import { render, staticRenderFns } from "./mailbox-parent.vue?vue&type=template&id=0cfff455&scoped=true"
import script from "./mailbox-parent.vue?vue&type=script&lang=js"
export * from "./mailbox-parent.vue?vue&type=script&lang=js"
import style0 from "./mailbox-parent.vue?vue&type=style&index=0&id=0cfff455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfff455",
  null
  
)

export default component.exports